/* Starlustre additions. Keep theme-native cart, variants and filters in Prestige. */
class StarlustreTabs extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.addEventListener('click', event => {
      const tab = event.target.closest('[role="tab"]');
      if (tab) this.select(tab);
    }, options);
    this.addEventListener('keydown', event => {
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const index = tabs.indexOf(event.target);
      if (index < 0) return;
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next === undefined) return;
      event.preventDefault(); this.select(tabs[next]); tabs[next].focus();
    }, options);
    this.addEventListener('shopify:block:select', event => {
      const tab = event.target.closest('[role="tab"]');
      if (tab) this.select(tab);
    }, options);
  }
  select(tab) {
    this.querySelectorAll('[role="tab"]').forEach(item => {
      const active = item === tab;
      item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1;
      const panel = this.querySelector(`#${CSS.escape(item.getAttribute('aria-controls'))}`);
      if (panel) panel.hidden = !active;
    });
  }
  disconnectedCallback() { this.controller?.abort(); }
}
class StarlustreSupport extends HTMLElement {
  connectedCallback() {
    this.controller?.abort(); this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    const dialog = this.querySelector('dialog'), trigger = this.querySelector('.sl-support__trigger');
    trigger.addEventListener('click', () => { dialog.showModal(); trigger.setAttribute('aria-expanded', 'true'); }, options);
    this.querySelector('[data-close]').addEventListener('click', () => dialog.close(), options);
    dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } }, options);
    dialog.addEventListener('close', () => { trigger.setAttribute('aria-expanded', 'false'); trigger.focus(); }, options);
  }
  disconnectedCallback() { this.querySelector('dialog')?.close(); this.controller?.abort(); }
}
class StarlustreExternalSupport extends HTMLElement {
  connectedCallback() {
    if (this.hasAttribute('data-editor')) { this.textContent = '第三方客服脚本仅在店面预览运行。'; return; }
    let url;
    try { url = new URL(this.dataset.src); } catch { return; }
    if (url.protocol !== 'https:') return;
    // A provider can install global handlers; changing providers requires a page reload.
    if (document.getElementById('starlustre-support-provider')) return;
    const script = document.createElement('script');
    script.id = 'starlustre-support-provider'; script.src = url.href; script.async = true;
    script.addEventListener('error', () => { this.dataset.loadFailed = 'true'; });
    document.head.append(script);
  }
}
for (const [name, ctor] of [['starlustre-tabs', StarlustreTabs], ['starlustre-support', StarlustreSupport], ['starlustre-external-support', StarlustreExternalSupport]]) {
  if (!customElements.get(name)) customElements.define(name, ctor);
}
// Native details provide keyboard operation without affecting the theme's filter forms.
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const details = event.target.closest('.sl-nav details[open], .sl-horizontal-filters details[open]');
  if (details) { details.open = false; details.querySelector('summary')?.focus(); }
});
document.addEventListener('click', event => {
  document.querySelectorAll('.sl-nav details[open], .sl-horizontal-filters details[open]').forEach(details => {
    if (!details.contains(event.target)) details.open = false;
  });
});

// Only public product context travels in query parameters; contact details stay in the POST body.
function starlustreEnquiryContext(root = document) {
  const params = new URLSearchParams(location.search);
  const product = (params.get('product') || '').slice(0, 255);
  const variant = (params.get('variant') || '').slice(0, 500);
  const path = params.get('product_url') || '';
  root.querySelectorAll('[data-sl-enquiry-context]').forEach(context => {
    if (!product) return;
    context.hidden = false;
    context.querySelector('[data-sl-enquiry-summary]').textContent = [product, variant].filter(Boolean).join(' — ');
    context.querySelector('[data-sl-enquiry-product]').value = product;
    context.querySelector('[data-sl-enquiry-variant]').value = variant;
    context.querySelector('[data-sl-enquiry-url]').value = /^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?products\/[a-z0-9-]+$/.test(path) ? location.origin + path : '';
    const message = context.closest('form')?.querySelector('textarea[name="contact[body]"]');
    if (message && !message.value) message.value = `I would like to enquire about ${product}${variant ? ' (' + variant + ')' : ''}.`;
  });
}
starlustreEnquiryContext();
document.addEventListener('shopify:section:load', event => starlustreEnquiryContext(event.target));
